import React from "react";
import Facts from "components/Facts";

import { addRoundedRect, borderRadius } from "../svgUtils";

const width = 180;
const height = 80;
const containingRadius = Math.sqrt(width * width + height * height) / 2;

export default {
  layout: { radius: containingRadius },
  render: {
    enter: (item) => {
      const { elem: e, label } = item;

      addRoundedRect(
        e,
        -width / 2,
        -height / 2,
        width,
        height,
        borderRadius,
        0.5
      )
        .attr("fill", "white")
        .attr("stroke", "black");

      e.append("text")
        .attr("x", -width / 2 + 2)
        .attr("y", -height / 2 + 12 + 2)
        .text(label);
    },
    update: (item) => {},
  },
  eventHandlers: {
    status: (item, data, ui) => {
      console.log(data);
    },
  },
  renderInfoHead: (t) => t.data || "(No full name)",
  renderInfoBody: (t) => (
    <Facts>
      <Facts.Fact label="Data" value={t.data || ""} />
    </Facts>
  ),
};
